import * as React from 'react';
import { Link } from 'react-router-dom';
import { AppMode } from '../../AppMode';
import { FilterSettings, OnFilterSettingsChange } from '../../Filter/FilterSettings';
import { JobCenterModelInterface } from '../../Model/JobCenterModelInterface';
import { JobVacancy } from '../../Model/JobVacancy';
import { RouteConstants } from '../../RouteConstants';
import { StaticSettings } from '../../StaticSettings';
import { Type } from '../../Type';
import { BranchFilter } from './BranchFilter';
import { IndustryFilter } from './IndustryFilter';
import { SearchTermFilter } from './SearchTermFilter';
import { SectorFilter } from './SectorFilter';

export interface FilterComponentProps<T extends JobCenterModelInterface> {
    models: T[],
    filterSettings: FilterSettings,
    onChange: OnFilterSettingsChange,
    showSector: boolean
    buttonTitle: string
    type: Type
}

export class FilterComponent<T extends JobCenterModelInterface> extends React.PureComponent<FilterComponentProps<T>> {
    public render() {
        const props = this.props;
        const filterSettings = props.filterSettings;
        const button = this.renderButton(props);
        const className = this.getClassName(props.type);

        return <div className={className}>
            <div className="jc-upper">
                <SearchTermFilter filterSettings={filterSettings} models={props.models} onChange={props.onChange}/>
            </div>
            <div className="jc-lower row">
                {this.renderIndustrySelectBox(props, filterSettings)}
                {this.renderSectorBox(props, filterSettings)}
                <BranchFilter filterSettings={filterSettings} models={props.models} onChange={props.onChange}/>
                {button}
            </div>
        </div>;
    }

    private renderIndustrySelectBox(props: FilterComponentProps<T>, filterSettings: FilterSettings) {
        const className = this.getIndustryColumnClass(props);

        return <div className={className}>
            <IndustryFilter filterSettings={filterSettings} models={props.models} onChange={props.onChange}/>
        </div>;
    }

    private getIndustryColumnClass(props: FilterComponentProps<T>) {
        if (StaticSettings.ui.filter.showSearchButton) {
            return props.showSector ? 'col-sm-5' : 'col-sm-6';
        } else {
            return props.showSector ? 'col-sm-6' : 'col-sm-12';
        }
    }

    private renderSectorBox(props: FilterComponentProps<T>, filterSettings: FilterSettings) {
        if (props.showSector) {
            return <div className={this.getSectorColumnClass()}>
                <SectorFilter filterSettings={filterSettings}
                              models={props.models as any as JobVacancy[]}
                              onChange={props.onChange}/>
            </div>;
        } else {
            return null;
        }
    }

    private getSectorColumnClass() {
        return StaticSettings.ui.filter.showSearchButton ? 'col-sm-4' : 'col-sm-6';
    }

    private getClassName(type: Type) {
        const inner = type === Type.Candidate ? 'candidate' : 'job-vacancy';

        return 'job-center-filter job-center-' + inner + '-filter';
    }

    private renderButton(props: FilterComponentProps<T>) {
        if (!StaticSettings.ui.filter.showSearchButton) {
            return undefined;
        }
        const route = this.getButtonRoute(props);
        const className = props.showSector ? 'col-sm-3' : 'col-sm-6';

        return <div className={className}>
            <Link role="button" className="jc-filter-button" to={route}>{props.buttonTitle}</Link>
        </div>;
    }

    private getButtonRoute(props: FilterComponentProps<T>) {
        if (StaticSettings.mode === AppMode.Both) {
            return props.type === Type.Candidate
                ? RouteConstants.Candidate
                : RouteConstants.JobVacancy;
        } else {
            return '/';
        }
    }
}
